import { render, staticRenderFns } from "./ListenerAlbumDetails.vue?vue&type=template&id=50ab508c&scoped=true"
import script from "./ListenerAlbumDetails.vue?vue&type=script&lang=js"
export * from "./ListenerAlbumDetails.vue?vue&type=script&lang=js"
import style0 from "./ListenerAlbumDetails.vue?vue&type=style&index=0&id=50ab508c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ab508c",
  null
  
)

export default component.exports